import { useEffect, useState } from "react";
import ButtonAdminpanel from "../../components/ButtonAdminpanel";
import InputField from "../../components/InputField";
import SubHeader from "../../components/SubHeader";
import { changePswdByUser } from "../../actions/userAction";
import { connect } from "react-redux";
import { useAuth } from "../../AuthProvider";
import { showSuccessMessage } from "../../utils/common";
import { ToastContainer } from "react-toastify";
import errorMessages from "../../constant/errorMessages";
import { size, trim, isEmpty } from "lodash";
import defaultValues from "../../constant/defaultValues";

const ChangePassword = (props) => {

    const { logout, isPreKYCUser, company_plan } = useAuth();
    const [formData, setFormData] = useState({
        current_pswd: "",
        new_pswd: "",
        confirm_new_pswd: ""
    });
    const [errors, setErrors] = useState({});
    const [isDisabled, setIsDisabled] = useState(false);
    const [show_current_pswd, setShowCurPswd] = useState(false);
    const [show_new_pswd, setShowNewPswd] = useState(false);
    const [show_confirm_pswd, setShowConfirmPswd] = useState(false);

    const { PASSWORD_FIELD_MAX_LENGTH } = defaultValues;

    const regex = /^(?=.*[A-Za-z])(?=.*\d)\S{8,}$/;



    const handleShowCurPassword = () => {
        setShowCurPswd(!show_current_pswd);
    };

    const handleShowNewPassword = () => {
        setShowNewPswd(!show_new_pswd);
    };

    const handleShowConfirmPassword = () => {
        setShowConfirmPswd(!show_confirm_pswd);
    };

    const handleFocusOut = (e) => {
        const errorsObj = { ...errors }
        const { name, value } = e.target;

        if (name === "current_pswd") {
            const currentPwd = trim(value);
            if (isEmpty(currentPwd)) {
                errorsObj.current_pswd = errorMessages.FIELD_REQUIRED;
            } else {
                errorsObj.current_pswd = "";
            }
        }
        if (name === "new_pswd") {
            const newPwd = trim(value);
            if (isEmpty(newPwd)) {
                errorsObj.new_pswd = errorMessages.FIELD_REQUIRED;
            }
            else if (size(newPwd) > PASSWORD_FIELD_MAX_LENGTH) {
                errorsObj.new_pswd = errorMessages.MAX_CHARACTERS_REACHED;
            } else if (regex.test(newPwd) == false) {
                errorsObj.new_pswd = errorMessages.STRONG_PASSWORD;
            } else {
                errorsObj.new_pswd = "";
            }

        }
        if (name === "confirm_new_pswd") {
            const confirmPwd = trim(value);
            const newPwd = trim(formData.new_pswd);
            if (isEmpty(confirmPwd)) {
                errorsObj.confirm_new_pswd = errorMessages.FIELD_REQUIRED;
            } else if (confirmPwd != newPwd) {
                errorsObj.confirm_new_pswd = errorMessages.MATCH_PASSWORD;
            } else {
                errorsObj.confirm_new_pswd = "";
            }
        }
        setErrors(errorsObj);
        return Object.keys(errorsObj).length == 0;
    }

    const handleChange = (e) => {
        setFormData((prev) => {
            return {
                ...prev,
                [e.target.name]: e.target.value
            }
        })
    }

    const validation = () => {
        const errorsObj = {}

        const currentPswd = trim(formData.current_pswd);
        const newPswd = trim(formData.new_pswd);
        const confirmNewPswd = trim(formData.confirm_new_pswd);

        if (isEmpty(currentPswd)) {
            errorsObj.current_pswd = errorMessages.FIELD_REQUIRED;
        }

        if (isEmpty(newPswd)) {
            errorsObj.new_pswd = errorMessages.FIELD_REQUIRED;
        } else if (size(newPswd) > PASSWORD_FIELD_MAX_LENGTH) {
            errorsObj.new_pswd = errorMessages.MAX_CHARACTERS_REACHED;
        } else if (!regex.test(newPswd)) {
            errorsObj.new_pswd = errorMessages.STRONG_PASSWORD;
        }

        if (isEmpty(confirmNewPswd)) {
            errorsObj.confirm_new_pswd = errorMessages.FIELD_REQUIRED;
        } else if (confirmNewPswd !== newPswd) {
            errorsObj.confirm_new_pswd = errorMessages.MATCH_PASSWORD;
        }

        setErrors(errorsObj);
        return Object.keys(errorsObj).length === 0;
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsDisabled(true);
        const isValid = await validation();
        if (isValid) {
            formData.confirm_new_pswd = trim(formData.confirm_new_pswd);
            formData.current_pswd = trim(formData.current_pswd);
            formData.new_pswd = trim(formData.new_pswd);
            await props.changePswdByUser(formData).then((response) => {
                if (response.status) {
                    if (response.data === "PSWD_CHANGED") {
                        showSuccessMessage(response.message);
                        setTimeout(() => {
                            setIsDisabled(true);
                            logout();
                        }, 3000);
                    }
                } else {
                    const errorsObj = {};
                    const result = Object.entries(response.error);

                    result.forEach(([key, value]) => {
                        errorsObj[key] = value[0];
                    });

                    setErrors(errorsObj);
                    setIsDisabled(false);

                }
            }).catch((err) => {
                console.log("Error ========= ", err);
                setIsDisabled(false);
            });
        } else {
            setIsDisabled(false);
        }
    }

    return (<div className="u-settings shipment-details">
        <SubHeader layer1="Settings" layer2="Change Password" layer3="" pageName="Change password" subTitle="" clickable={{
            layer1: "",
            layer2: "",
            layer3: ""
        }} />
        <div className='bg-white px-4 card-shadow rounded'>
            <form onSubmit={handleSubmit} >
                <div className="row pt-4">
                    <div className="col-md-2">
                        <label>Current Password:<span class="text-danger"> *</span></label>
                    </div>
                    <div className="col-md-4">
                        <div className="input-wrape">
                            <div className="input-pad">
                                <InputField
                                    type={show_current_pswd ? "text" : "password"}
                                    onChange={handleChange}
                                    placeholder={"Enter current password"}
                                    className={"input-error-border mr-input"}
                                    value={formData.current_pswd}
                                    name="current_pswd"
                                    onBlur={handleFocusOut}
                                    //disabled={props.disableProfile}
                                    autoComplete="off"
                                />
                                <span
                                    className="input-group-text"
                                    onClick={handleShowCurPassword}
                                >
                                    <i className={!show_current_pswd ? "fa-regular fa-eye" : "fa-solid fa-eye-slash"}></i>
                                    {/* <i className="fa-regular fa-eye"></i> */}
                                </span>
                            </div>
                            {
                                errors.current_pswd && <span
                                    className="company-required-content"
                                    style={{ display: "block" }}
                                >
                                    {errors.current_pswd}
                                </span>
                            }
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-2">
                        <label>New Password:<span class="text-danger"> *</span></label>
                    </div>
                    <div className="col-md-4">
                        <div className="input-wrape">
                            <div className="input-pad">
                                <InputField
                                    type={show_new_pswd ? "text" : "password"}
                                    onChange={handleChange}
                                    placeholder={"Enter new password"}
                                    className={"input-error-border mr-input"}
                                    value={formData.new_pswd}
                                    name="new_pswd"
                                    onBlur={handleFocusOut}
                                    //disabled={props.disableProfile}
                                    autoComplete="off"
                                />
                                <span
                                    className="input-group-text"
                                    onClick={handleShowNewPassword}
                                >
                                    <i className={!show_new_pswd ? "fa-regular fa-eye" : "fa-solid fa-eye-slash"}></i>
                                    {/* <i className="fa-regular fa-eye"></i> */}
                                </span>
                            </div>
                            {
                                errors.new_pswd && <span
                                    className="company-required-content"
                                    style={{ display: "block" }}
                                >
                                    {errors.new_pswd}
                                </span>
                            }

                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-2">
                        <label>Confirm New Password:<span class="text-danger"> *</span></label>
                    </div>
                    <div className="col-md-4">
                        <div className="input-wrape">
                            <div className="input-pad">
                                <InputField
                                    type={show_confirm_pswd ? "text" : "password"}
                                    onChange={handleChange}
                                    placeholder={"Enter confirm new password"}
                                    className={"input-error-border mr-input"}
                                    value={formData.confirm_new_pswd}
                                    name="confirm_new_pswd"
                                    onBlur={handleFocusOut}
                                    //disabled={props.disableProfile}
                                    autoComplete="off"
                                />
                                <span
                                    className="input-group-text"
                                    onClick={handleShowConfirmPassword}
                                >
                                    <i className={!show_confirm_pswd ? "fa-regular fa-eye" : "fa-solid fa-eye-slash"}></i>
                                    {/* <i className="fa-regular fa-eye"></i> */}
                                </span>
                            </div>
                            {
                                errors.confirm_new_pswd && <span
                                    className="company-required-content"
                                    style={{ display: "block" }}
                                >
                                    {errors.confirm_new_pswd}
                                </span>
                            }
                        </div>
                    </div>
                </div>
                <div className="row pb-4">
                    <div className="col-md-2">
                        <label></label>
                    </div>
                    <div className="col-md-4">
                        <ButtonAdminpanel type="submit" isDisabled={isDisabled}>Update Password</ButtonAdminpanel>
                    </div>
                </div>
            </form>
            {/* {!isPreKYCUser && company_plan !== null && company_plan !== 'Trial' &&
                <ToastContainer />
            }    */}
        </div>
    </div>)
}

const mapStateToProps = (state) => {
    return {}
}

const mapDispatchToProps = (dispatch) => {
    return {
        changePswdByUser: (data) => dispatch(changePswdByUser(data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);